module.exports = "https://static-production.npmjs.com/255a118f56f5346b97e56325a1217a16.svg";